// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__uFbm_","label":"Labeled_label__2c9Ak","divider":"Labeled_divider__3F1Da"};